import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Footer from "../components/Footer";
import PageWrapper from "../components/PageWrapper";
import "./About.css";

export default function About() {
  const { t } = useTranslation();
  return (
    <PageWrapper>
      <div
        style={{
          padding: "80px 30px 30px 30px",
          maxWidth: "900px",
          margin: "auto",
          whiteSpace: "pre-wrap",
        }}
      >
        <h1>{t("about_us_title")}</h1>
        <p>{t("about_us_content")}</p>
        <p>
          <Link to="/ads-api">{t("ads_api_about_link")}</Link>
        </p>
        <img className="logo" alt="" src="./assets/logo.png" />
      </div>
      <Footer />
    </PageWrapper>
  );
}
